import React, { useState } from 'react';
import styled from '@emotion/styled';
import {Input} from 'reactstrap';
import CustomButton from './CustomButton';
import { Select } from '@material-ui/core';


const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 32px;
    width: 429px;
    height: 611px;
    justify-content: space-between;
    background: #FFFFFF;
    border-radius: 20px;
    .text-area{
        padding: 12px 16px;
        width: 100%;
        height: 81px;
        resize: none;
        /* default/shade/white */

        background: #FFFFFF;
        /* default/gray/300 */

        border: 1px solid #D3D9DE;
        box-sizing: border-box;
        border-radius: 4px;
    }
    #categories{
        padding: 12px 16px;
        width: 100%;

        background: #FFFFFF;
        /* default/gray/300 */
        border: 1px solid #D3D9DE;
        box-sizing: border-box;
        border-radius: 4px;
    }
    .input-area{
        width: 100%;
        background: #FFFFFF;
        /* default/gray/300 */

        border: 1px solid #D3D9DE;
        box-sizing: border-box;
        border-radius: 4px;
    ::placeholder{
        font-family: 'Inter', sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 14px;
        /* identical to box height, or 100% */

        display: flex;
        align-items: center;

        /* default/gray/500 */

        color: #8D9AA5;
    }
    }
`;
const Heading = styled.h1`
    font-family: 'Inter', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 20px;
    /* identical to box height, or 100% */

    display: flex;
    align-items: center;

    color: #000000;
`;
const ImageContainer = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: center;
    width: 100%;
    height: 240px;
    justify-content: center;
    /* default/gray/100 */

    background: #F6F8F8;
    /* default/gray/300 */

    border: 1px dashed #D3D9DE;
    border-radius: 12px;
    input[type="file"] {
        display: none;
    }
    .custom-file-upload{
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        padding: 4px 8px;
        cursor: pointer;
        /* width: 74px;
        height: 20px; */
        display: flex;
        align-items: center;
        /* Company */
        background: #02B2D9;
        border-radius: 20px;
        font-family: 'Inter', sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        line-height: 12px;
        /* identical to box height, or 100% */

        /* default/shade/white */

        color: #FFFFFF;
    
    }
    .description{
        font-family: 'Inter', sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 8px;
        line-height: 8px;
        color: var(--color-gray-500);
        margin-top: 8px;
    }
    .image{
        margin-bottom: 24px;
    }
`;
const ModalImage = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 240px;
    border-radius: 12px;
    overflow: hidden;
    img{
        object-fit: cover;
        position: relative;
        width: 100%;
        height: 100%;
    }
    .edit-button{
        position: absolute;
        cursor: pointer;
        width: 30px;
        height: 30px;
        top: 16px;
        right: 16px;
    }
`;
const ModalTextContainer = styled.div`
    display: flex;
    padding-bottom: 9px;
    justify-content: space-between;
    width: 100%;
    .main{
        font-family: 'Inter', sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 14px;
        /* identical to box height, or 100% */
        /* default/gray/500 */
        color: #8D9AA5;
    }
    .sub{
        font-family: 'Inter', sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 10px;
        line-height: 10px;
        /* identical to box height, or 100% */

        /* default/gray/500 */

        color: #8D9AA5;
    }
`;

const ModalButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

const CancelButton = styled.button`
    outline: none;
    font-family: 'Inter', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height, or 100% */
    /* default/gray/700 */
    color: #525B64;
    padding: 8px 16px;
    border: 2px solid #000;
    border-radius: 10px;
`;

const DoneButton = styled.button`
    outline: none;
    display: flex;
    align-items: center;
    font-family: 'Inter', sans-serif;
    font-style: normal;
    padding: 8px 16px;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    background: ${props => (props.background ? 'var(--company-dark)' : 'var(--color-gray-300)')};
    border-radius: 6px;
    color: var(--color-white);
`;

export const PopUp = ({type, category, setCategory, setTitle, setDescription, setImage, checked,
    setCancel, title, description, image, addOffer, updateOffer, update}) => {
    const [imageSelected, setImageSelected] = useState(image);
    const uploadImage = (input) => {
        if (input.files && input.files[0]) {
            const reader = new FileReader();
            reader.onload = function (e) {
                setImageSelected(e.target.result);
                setImage(e.target.result)
            };
            reader.readAsDataURL(input.files[0]); // convert to base64 string
        }
    }
    const clearImage = () => {
        setImage('');
        setImageSelected('');
    }
    return (
        <ModalContainer style={{height: type === 'post' && '650px'}}>
            { type === 'offer' ?
                <Heading>New Offer</Heading>
                :
                <Heading>New Post</Heading>
            }
            {!imageSelected ?
                (
                    <ImageContainer>
                        <img className="image" src="/img/image_placeholder.svg" alt="placeholder"/>
                        <label class="custom-file-upload">
                            <input type="file" onChange={(e) => uploadImage(e.target)}/>
                            Choose an Image
                        </label>
                        <span className="description">(Image size should be 1280 x 720 minimum)</span>
                    </ImageContainer>
                )
                :
                (
                    <ModalImage>
                        <img src={imageSelected} alt="live"/>
                        <img className="edit-button" src="/img/edit_image.png" alt="edit" onClick={() => clearImage()}/>
                    </ModalImage>
                )
            }
            { type === 'post' &&
                <div style={{width: '100%'}}>
                    <ModalTextContainer>
                        <span className="main">Category</span>
                    </ModalTextContainer>
                    <select name="category" value={category} id="categories" onChange={(e) => setCategory(e.target.value)}>
                        <option value=""></option>
                        <option value="Events">Events</option>
                        <option value="Partnerships">Partnerships</option>
                    </select>
                </div>
            }
            <div style={{width: '100%'}}>
                <ModalTextContainer>
                    <span className="main">Title</span>
                    <span className="sub">Maximum 34 Characters</span>
                </ModalTextContainer>
                <Input type="text" placeholder="Enter a Title" value={title} maxLength={34} onChange={(e) => setTitle(e.target.value)}/>
            </div>
            <div style={{width: '100%'}}>
                <ModalTextContainer>
                    <span className="main">Description</span>
                    <span className="sub">Maximum 90 Characters</span>
                </ModalTextContainer>
                {/* <Input type="text" placeholder="Outline the details of the offer here" height={500}/> */}
                { type === 'offer' ?
                    (
                        <textarea className="text-area" defaultValue={description} placeholder="Outline the details of the offer here"
                            maxLength={90} onChange={(e) => setDescription(e.target.value)}/>
                    )
                    :
                    (
                        <textarea className="text-area" defaultValue={description} placeholder="Outline the details of the post here"
                            maxLength={90} onChange={(e) => setDescription(e.target.value)}/>
                    )
                }
            </div>
            <ModalButtonContainer>
                {!update ?
                    <DoneButton background={checked()} onClick={() => addOffer()}>Done</DoneButton>
                    :
                    <DoneButton background={checked()} onClick={() => updateOffer()}>Done</DoneButton>
                }
                <CancelButton onClick={() => setCancel(false)}>Cancel</CancelButton>
            </ModalButtonContainer>
        </ModalContainer>
    );
}
export default PopUp;